import React from "react";

export default function Client() {
  const cards = [
    { image: "logos/1.png" },
    { image: "logos/2.jpg" },
    { image: "logos/3.jpg" },
    { image: "logos/4.jpg" },
    { image: "logos/5.jpeg" },
    { image: "logos/6.jpg" },
    { image: "logos/7.jpg" },
    { image: "logos/8.png" },
    { image: "logos/9.png" },
    { image: "logos/10.png" },
    { image: "logos/11.png" },
    { image: "logos/12.jpg" },
    { image: "logos/13.png" },
    { image: "logos/14.jpeg" },
    { image: "logos/15.png" },
    { image: "logos/16.png" },
    { image: "logos/17.jpeg" },
    {image :"logos/21.png" },
    {image :"logos/22.png" },
    {image :"logos/23.png" },
    {image :"logos/24.jpeg" },
    {image :"logos/25.jpeg" }
  ];

  return (
    <div className="my-40">
      {/* Section Title */}
      <div className="text-center mx-20 my-8 text-4xl font-bold tracking-wide uppercase bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 text-transparent bg-clip-text">
        Some of Our Esteemed Clients
      </div>

      {/* Grid of Client Logos */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 p-6 bg-gray-100">
        {cards.map((card, index) => (
          <div
            key={index}
            className="bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-2xl transition-shadow"
          >
            <img
              src={card.image}
              alt={`Client Logo ${index + 1}`}
              className="w-full h-40 object-contain p-4 bg-gray-50"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
